module.exports = __webpack_public_path__ + "static/media/IMG_2216.ea390382.JPG";